import React, { Component, PureComponent } from 'react'
import DataTable from '../datatable'
import { Map, List, fromJS } from 'immutable'

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
  },
  {
    name: 'data.roleFeatures',
    label: 'Ominaisuudet',
    align: 'center',
    width: 140,
    render(item, column) {
      return (
        <div className="tags">
          <div className="tags-item tags-item--blue">{item.getIn(['data', 'roleFeatures'], List()).size}</div>
        </div>
      )
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
]

export default function UserRolesRoot() {
  return (
    <DataTable
      id="user_roles"
      entity="user_role"
      crud
      title="Käyttäjäroolit"
      texts={{ createButton: 'Lisää käyttäjärooli' }}
      columns={columns}
    />
  )
}
